
const state = {
  sidebar: {
    opened: true,
  },
  breadArr : [],
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
  },
  CLOSE_SIDEBAR: (state, { isOpenSidebar }) => {
    state.sidebar.opened = isOpenSidebar
  },
  UPDATE_BREADARR: (state, params) => {
    state.breadArr = params
  },
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  toggleSideBarByParams({ commit }, params) {
    commit('CLOSE_SIDEBAR', params)
  },
  updateBreadArr({ commit }, params) {
    commit('UPDATE_BREADARR', params)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
